import { Button, ButtonSize, HoverStyles } from '@wix/wix-ui-tpa/cssVars';
import classNames from 'classnames';
import React from 'react';
import { ForcedState, useForcedState } from '../../../../../contexts/forced-state-context';
import { classes } from './next-button.st.css';
const NextButton = ({ nextText, className, onClick })=>{
    const forcedState = useForcedState();
    const hover = forcedState.includes(ForcedState.NEXT_BUTTON_HOVER);
    return /*#__PURE__*/ React.createElement(Button, {
        className: classNames(classes.nextButton, {
            [classes.nextButtonHover]: hover
        }, className),
        hoverStyle: HoverStyles.underline,
        upgrade: true,
        wrapContent: true,
        size: ButtonSize.large,
        onClick: onClick,
        "data-hook": "next-button"
    }, nextText);
};
export default NextButton;

//# sourceMappingURL=next-button.js.map